import React, {useEffect, useState} from 'react';

import classNames from 'classnames';
import {isEmpty} from 'lodash';
import {Button, Card, Col, Row} from 'reactstrap';

import {LoadingSpinner} from 'components/Loading';
import {PublicCompanyLogo} from 'components/Publics';
import {useAuth} from 'contexts/AuthContext';
import {useCommonData} from 'contexts/CommonDataContext';
import LoginDefaultModal from 'views/login/LoginDefaultModal';

import useGetCBs from './useGetCBs';

import styles from './styles.module.scss';

const CBCard = (props) => {
  const {cbData, countries} = props;

  const {
    countries_id,
    certification_bodies_name,
    certification_bodies_id,
    files,
  } = cbData || {};
  const country = countries[countries_id];
  const {name: countryName} = country || {};

  return (
    <Card className={classNames(styles['cb__card'], 'position-relative')}>
      <div className="d-flex flex-row align-items-center">
        <div>
          <PublicCompanyLogo
            companyType="cb"
            file={files}
            size={'sm'}
            className="rounded-circle mb-0 mr-2"
          />
        </div>
        <div style={{maxWidth: '80%'}}>
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <a
              id={`tooltip-cb-${certification_bodies_id}`}
              href={`/certification-body/${certification_bodies_id}`}
              className="stretched-link"
              title={certification_bodies_name}
            >
              {certification_bodies_name}
            </a>
          </div>
          <div className="d-flex flex-row align-items-center">
            <p className="mb-0">{countryName}</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

function ABCertificationBody() {
  const {data, meta, isLoading, reload} = useGetCBs();
  const {countries} = useCommonData();
  const {isAuth} = useAuth();

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const modalProps = {
    isOpen,
    toggle,
  };

  // When user logged in
  useEffect(() => {
    if (isAuth) setIsOpen(false);
  }, [isAuth]);

  const {offset, total_pages, total_rows} = meta || {};
  const loadMore = () => reload(isAuth);
  const hasMore = parseInt(offset) + 1 < parseInt(total_pages);

  return (
    <section>
      <h3 className={styles['section__title']}>
        Certification Body {`(${total_rows || 0})`}
      </h3>
      {!isEmpty(data) && (
        <Row
          className={classNames(styles['cb__container'], 'list-unstyled')}
          tag="ul"
        >
          {data.map((cb, index) => {
            return (
              <Col key={'CB' + index} lg={12} xl={4} className="my-2" tag="li">
                <CBCard cbData={cb} countries={countries} />
              </Col>
            );
          })}
          {isLoading && (
            <div className="text-center mb-4 mx-auto w-100">
              <LoadingSpinner />
            </div>
          )}
          {hasMore && (
            <Button
              block
              outline
              color="primary"
              onClick={isAuth ? loadMore : toggle}
              disabled={isLoading}
              className={classNames(
                styles['cb__load-more-btn'],
                'rounded mx-3 mt-2'
              )}
            >
              Load more
            </Button>
          )}
        </Row>
      )}

      <LoginDefaultModal {...modalProps} redirect={false} />
    </section>
  );
}

export default ABCertificationBody;
